/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type GetContactTracingCompletionStatus200 =
  (typeof GetContactTracingCompletionStatus200)[keyof typeof GetContactTracingCompletionStatus200];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetContactTracingCompletionStatus200 = {
  UNKNOWN: 'UNKNOWN',
  COMPLETED: 'COMPLETED',
  NOT_COMPLETED: 'NOT_COMPLETED',
} as const;
